import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { createInitialValues, validatePasswordConfirm } from 'client/helpers/formikHelpers';

import ButtonDeprecated, {
  BUTTON_THEME_YELLOW,
} from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

const formFields = [
  {
    id: 'password',
    type: 'password',
    title: 'Create your new password',
    autoComplete: 'false',
    properties: {
      autoComplete: 'false',
      placeholder: 'New password',
    },
    placeholder: 'new password',
    validations: ['required'],
  },
  {
    id: 'confirmPassword',
    type: 'password',
    autoComplete: 'off',
    properties: {
      autoComplete: 'false',
      placeholder: 'Confirm password',
    },
    placeholder: 'confirm new password',
    validations: ['required'],
  },
];

class SrPasswordResetForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    locationQuery: PropTypes.object.isRequired,
  };

  render() {
    const {
      onSubmit,
      locationQuery,
    } = this.props;
    const initialValues = createInitialValues({
      formFields: formFields,
    });

    const resetPasswordFormFields = formFields.map((formField) => {
      if (formField.id === 'password' && locationQuery.userName && locationQuery.listingAddress) {
        return {
          ...formField,
          title: `Hi ${locationQuery.userName}, complete your account to see your tour at  ${locationQuery.listingAddress}`, // eslint-disable-line max-len
        };
      }

      return formField;
    });

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validateOnChange={false}
        validate={(values) => {
          return validatePasswordConfirm(values.password, values.confirmPassword);
        }}
        onSubmit={onSubmit}
        render={(formikBag) => {
          return (
            <Form>
              {resetPasswordFormFields.map((formField) => (
                <SrFormikField
                  key={formField.id}
                  formField={formField}
                  formikBag={formikBag}
                />
              ))}
              <ButtonDeprecated
                type='submit'
                theme={BUTTON_THEME_YELLOW}
              >
                {locationQuery.userName && locationQuery.listingAddress ? 'see my tour' : 'log back in'}
              </ButtonDeprecated>
            </Form>
          );
        }}
      />
    );
  }
}

SrPasswordResetForm.displayName = 'SrPasswordResetForm';

export default SrPasswordResetForm;
